export function truncateStringWithEllipsis(text: string, length: number): string {
  if (!text) {
    return '';
  }
  if (text.length <= length) {
    return text;
  }
  return `${text.slice(0, length)}…`;
}
